module.exports = __webpack_public_path__ + "static/media/tv-light-gray.4931d08b.svg";